import request from "../utils/fetch";

// 新增区域
export function addZone(data) {
  return request({
    url: "/equipment/region/add",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 区域列表
export function zoneList(data) {
  return request({
    url: "/equipment/region/list",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 批量导入
export function uploadCard(data) {
  return request({
    url: "/user/futureRegionCard/batch/bind?regionId=" + data.regionId,
    method: "post",
    requestBody: "upload",
    loading: true,
    data: data.file,
  });
}

// 修改区域
export function editZone(data) {
  return request({
    url: "/equipment/region/update",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 删除区域
export function delZone(data) {
  return request({
    url: "/equipment/region/del",
    method: "DELETE",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 区域详情
export function zoneInfo(data) {
  return request({
    url: "/equipment/region/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 组内设备表格
export function shebeiTable(data) {
  return request({
    url: "/equipment/region/device/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 设备分组末班下载
export function shebeiTemplate(data) {
  return request({
    url: "/equipment/region/download",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
    header: {
      headers: { "Content-Type": "application/x-download" },
    },
    responseType: "blob",
  });
}

// 分配设备导入
export function shebeiUpload(data) {
  return request({
    url: "/equipment/region/upload?id=" + data.id,
    method: "post",
    requestBody: "upload",
    loading: true,
    data: data.file,
  });
}

// 组内设备移除
export function delShebei(data) {
  return request({
    url: "/equipment/region/del/device",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 未分区设备列表
export function notShebeiList(data) {
  return request({
    url: "/equipment/region/not/device/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 手动绑定设备分区
export function handBindShebei(data) {
  return request({
    url: "/equipment/region/bind/device",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 组内水卡表格
export function cardTable(data) {
  return request({
    url: "/user/futureRegionCard/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 组内水卡移除
export function delCard(data) {
  return request({
    url: "/user/futureRegionCard/del",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 单卡分配
export function oneBindCard(data) {
  return request({
    url: "/user/futureRegionCard/bind",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 批量卡分配
export function moreBindCard(data) {
  return request({
    url: "/user/futureRegionCard/batch/bind",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 组内员工表格
export function peopleTable(data) {
  return request({
    url: "/user/region/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 员工下拉
export function peoplePull(data) {
  return request({
    url: "/user/afterSales/user/pullList",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 员工分配
export function peopleBind(data) {
  return request({
    url: "/user/region/bind",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 组内员工移除
export function delPeople(data) {
  return request({
    url: "/user/region/del",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 水卡充值
export function cardTop(data) {
  return request({
    url: "/order/water/ticket/order/admin/batch/create",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 套餐列表
export function menuList(data) {
  return request({
    url: "/order/water/ticket/package/region/list",
    method: "post",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 新增套餐
export function addMenu(data) {
  return request({
    url: "/order/water/ticket/package/region/add",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 删除套餐
export function delMenu(data) {
  return request({
    url: "/order/water/ticket/package/region/del",
    method: "DELETE",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 区域下拉
export function zonePull(data) {
  return request({
    url: "/equipment/region/pull/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 查询充值结果
export function topList(data) {
  return request({
    url: "/order/water/ticket/order/list/by/batch",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 水卡导出
export function cardExport(data) {
  return request({
    url: "/user/futureRegionCard/export",
    method: "get",
    requestBody: "body",
    loading: true,
    params: data,
    header: {
      headers: { "Content-Type": "application/x-download" },
    },
    responseType: "blob",
  });
}

// 设备导出
export function equipmentExport(data) {
  return request({
    url: "/equipment/region/export",
    method: "get",
    requestBody: "body",
    loading: true,
    params: data,
    header: {
      headers: { "Content-Type": "application/x-download" },
    },
    responseType: "blob",
  });
}

// 消费统计
export function xiaofeiState(data) {
  return request({
    url: "/order/statistics/customer/consume/get/sum",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 充值统计
export function chongzhiState(data) {
  return request({
    url: "/order/statistics/customer/recharge/get/sum",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 区域信息水卡想去
export function zoneCardNum(data) {
  return request({
    url: "/user/futureRegionCard/cardAnduserAndequipment/count",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 组内客户列表
export function zoneClient(data) {
  return request({
    url: "/user/foreign/api/region/user/byId",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 客户导出
export function clientExport(data) {
  return request({
    url: "/user/foreign/api/export/region/user",
    method: "get",
    requestBody: "body",
    loading: true,
    params: data,
    header: {
      headers: { "Content-Type": "application/x-download" },
    },
    responseType: "blob",
  });
}

// 活动充值查询
export function activeCha(data) {
  return request({
    url: "/order/company/pay/settings/get/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
